import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../share/service/auth.service";
import { UserService } from "src/app/share/service/user.service";
import {
	PRODUCT_TRANSACTIONS,
	PRODUCT_QUOTATIONS,
	PRODUCT_USER_MANAGEMENT,
	PRODUCT_COMPANY_SETUP,
} from "src/app/share/constants/access.constants";

@Component({
    selector: "app-drawer",
    templateUrl: "./drawer.component.html",
    styleUrls: ["./drawer.component.scss"],
    standalone: false
})
export class AppDrawerComponent implements OnInit {
	tab: string;

	showTabQuotations: boolean = false;
	showTabTransactions: boolean = false;
	showTabUserManagement: boolean = false;
	showTabCompany: boolean = false;

	constructor(
		private authService: AuthService,
		private router: Router,
		public userService: UserService,
	) {}

	ngOnInit(): void {
		this.checkDrawer();
		// if (this.router.url.includes("motor")) {
		//   this.tab = "motor";
		// }
	}

	checkDrawer() {
		let getProductPermissions = localStorage.getItem("getProductPermissions");

		if (getProductPermissions) {
			let product_list = eval(localStorage.getItem("getProductPermissions"));
			product_list.forEach((x) => {
				if (x == PRODUCT_QUOTATIONS) this.showTabQuotations = true;
				if (x == PRODUCT_TRANSACTIONS) this.showTabTransactions = true;
				if (x == PRODUCT_USER_MANAGEMENT) this.showTabUserManagement = true;
				if (x == PRODUCT_COMPANY_SETUP) this.showTabCompany = true;
			});
		}
	}

	logout() {
		this.authService.logout();
	}
}
